module.exports = __webpack_public_path__ + "img/service-icon1.a1dbc507.png";